import { render } from "./Private.vue?vue&type=template&id=22aba9d6&scoped=true"
const script = {}

import "./Private.vue?vue&type=style&index=0&id=22aba9d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22aba9d6"]])

export default __exports__